import { mapActions, mapState } from 'vuex';
import { Section, Center, LoadingAnimation } from '@styled/global';
import styled from 'vue-styled-components';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   color: #007582;\n   font-size: 13px;\n   line-height: 20px;\n   margin: 20px 0 50px 0;\n   width: 100%;\n   text-align: left;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   color: #000;\n   font-size: 18px;\n   line-height: 22px;\n   padding: 10px 0 20px 0;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   color: #000;\n   font-size: 18px;\n   line-height: 23px;\n   font-weight: bold;\n   margin: 10px 0 10px 0;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   color: #007582;\n   font-size: 64px;\n   line-height: 64px;\n   margin-top: 20px;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   width: 100%;\n   margin: auto;\n   flex-direction: column;\n   justify-content: center;\n   align-items: center;\n   border-top: 1px solid #000;\n   border-bottom: 1px solid #000;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Border = styled("div", {})(_templateObject());
var RatePercentage = styled("label", {})(_templateObject2());
var Type = styled("div", {})(_templateObject3());
var Details = styled("div", {})(_templateObject4());
var Assumptions = styled("div", {})(_templateObject5());

var script = {
  props: {
    copy: {
      required: false,
      type: Object
    }
  },
  data: function data() {
    return {
      numberFormatter: null
    };
  },
  methods: _extends({}, mapActions("introductory-rates", ["loadRates"])),
  computed: _extends({}, mapState("introductory-rates", ["rates"])),
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var numberFormatter;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadRates();

            case 2:
              _context.next = 4;
              return import(
              /* webpackChunkName: "number-formatter" */
              'number-formatter');

            case 4:
              numberFormatter = _context.sent;
              _this.numberFormatter = numberFormatter.default;

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  render: function render() {
    var h = arguments[0];

    if (this.rates && this.numberFormatter) {
      var copy = this.copy;
      var rates = this.rates;
      var numberFormatter = this.numberFormatter;
      var formattedRate = numberFormatter("#,###.###%", rates.rate);
      var formattedDiscount = numberFormatter("#,##0.000%", rates.discount);
      var formattedWithdrwalRate = numberFormatter("#,##0.000%", rates.withdrawal.rate);
      var formattedWithdrwalAmount = numberFormatter("$#,###.", rates.withdrawal.amount);
      var formattedLOC = numberFormatter("$#,###.", rates.loc);
      var details = copy.details.replace("${amount}", formattedWithdrwalAmount).replace("${discount}", formattedDiscount).replace("${rate}", formattedWithdrwalRate);
      var assumptions = copy.assumptions.replace("${loc}", formattedLOC);
      return h(Section, [h(Center, {
        "attrs": {
          "flexDirection": "column"
        }
      }, [h(Border, [h(RatePercentage, [formattedRate]), h(Type, [copy.type]), h(Details, [details])]), h(Assumptions, [assumptions])])]);
    }

    return h(Section, {
      "attrs": {
        "height": ["241px"]
      }
    }, [h(Center, [h(LoadingAnimation)])]);
  }
}; // Store loader function called by LazyContainer to dynamically preload stores required by this component

var storeLoader = function storeLoader() {
  return function () {
    return [{
      name: "introductory-rates",
      store: function store() {
        return import(
        /* webpackChunkName: "introductory-rates-store" */
        '@stores/introductory-rates');
      }
    }];
  };
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
export { storeLoader };
